import InstagramFeed from "../components/InstagramFeed";
import TwitterFeed from "../components/TwitterFeed";

export default function Media() {
  return (
    <div className="bg-demolition-black min-h-screen" data-testid="media-page">
      {/* Header */}
      <section className="relative py-24 px-6 md:px-12 overflow-hidden">
        <div className="absolute inset-0 steel-mesh opacity-20" />
        <div className="max-w-7xl mx-auto relative z-10">
          <div className="text-center">
            <h1 
              className="font-russo text-5xl sm:text-6xl lg:text-7xl text-white uppercase tracking-tighter mb-4"
              data-testid="media-title"
            >
              MEDIA GALLERY
            </h1>
            <p className="font-teko text-xl sm:text-2xl text-demolition-chrome uppercase tracking-widest">
              Photos & Social Feeds from the Demolition Era
            </p>
          </div>
        </div>
      </section>

      {/* Instagram Feed */}
      <section className="py-16 px-6 md:px-12 bg-demolition-paper" data-testid="instagram-section">
        <div className="max-w-7xl mx-auto">
          <InstagramFeed showHeader={true} />
        </div>
      </section>

      {/* X / Twitter Feed */}
      <section className="py-16 px-6 md:px-12 bg-demolition-black" data-testid="twitter-section">
        <div className="max-w-7xl mx-auto">
          <TwitterFeed showHeader={true} />
        </div>
      </section>
    </div>
  );
}
